import React from 'react';
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';
import Glossary from '../Glossary/Glossary'

const ICAGlossaryScreen = props => {
  return (
    <Layout product='stratPlan'>
      <PageHeader title='Glossary'>
        <Glossary/>
      </PageHeader>
    </Layout>
  )
}
export default ICAGlossaryScreen
